module.exports = __webpack_public_path__ + "img/bg6-2.fd845cd9.png";